import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

import CircularProgress from "@mui/material/CircularProgress";

import LineChart from "../../shared/charts/LineChart";
import { MeasurementDetail, Measurement } from "../../shared/interfaces/Result";
import { MeasurementType } from "../../shared/enums/Result";
import { MessageCard, MessageType } from "../../shared/MessageCard";

import { useMeasurementHistoryChartOptions } from "./MeasurementHistoryHooks/useMeasurementHistoryChartOptions";

interface Props {
  loading?: boolean;
  measurementHistory?: MeasurementDetail<Measurement>[];
  measurementType: MeasurementType;
}

export function MeasurementHistoryChart(props: Props) {
  const { t } = useTranslation();

  const measurementHistoryChartOptions = useMeasurementHistoryChartOptions(
    props.measurementHistory,
    props.measurementType,
  );

  const xAxisConfig: Highcharts.XAxisOptions = {
    type: "datetime",
    labels: {
      formatter: function (this: any) {
        const dateTime = DateTime.fromMillis(this.value);
        return t("common.formattedDateShort", { dateString: dateTime.toISO() });
      },
    },
  };

  if (props.loading) {
    return <CircularProgress size={65} />;
  } else if (measurementHistoryChartOptions) {
    const dataSeries = measurementHistoryChartOptions.series.flatMap((series) => series.data);

    return dataSeries != null && dataSeries.length !== 0 ? (
      <LineChart
        series={measurementHistoryChartOptions.series}
        yAxisSettings={measurementHistoryChartOptions.yAxisConfig}
        xAxisSettings={xAxisConfig}
        xAxisType="datetime"
        sharedTooltip
      />
    ) : (
      <MessageCard
        title={t("results.noHistory")}
        secondaryText={t("results.noHistoryDescription")}
        messageType={MessageType.Info}
      />
    );
  } else {
    return null;
  }
}
